import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReact, faFontAwesome } from "@fortawesome/free-brands-svg-icons";
import {
  faHardHat,
  faHeart,
  faCoffee,
  faPhone,
  faEnvelope,
  faSun,
  faMoon,
} from "@fortawesome/free-solid-svg-icons";

import "./Footer.css";
const body = document.querySelector("body");

export default function Footer() {
  const [data, setData] = useState({
    language: "",
  });
  let activeTheme = false;
  let language = localStorage.getItem("language");

  function changeData(e) {
    setData({ language: e.target.value });
    window.scrollTo(0, 0);
    window.location.reload();
  }

  function setTheme() {
    if (!activeTheme) {
      body.style.backgroundColor = "#111";
      body.style.color = "#999";
      activeTheme = true;
    } else {
      body.style.backgroundColor = "#eee";
      body.style.color = "#000";
      activeTheme = false;
    }
  }

  useEffect(() => {
    if (data.language) {
      localStorage.setItem("language", data.language);
    }
  }, [data, language]);

  return (
    <footer className="footer">
      <div className="footer__touch">
        <p>Yojhan Alejandro Atuesta Mendoza</p>
        <p style={language === "english" ? {} : { display: "none" }}>
          Get in touch!
        </p>
        <p
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          ¡Pongámonos en contacto!
        </p>
        <p>
          <FontAwesomeIcon icon={faPhone} />
          (+57) 3046377855
        </p>
        <a href="mailto:aatuesta00@hotmai.com" target="blank" rel="noreferrer">
          <p>
            <FontAwesomeIcon icon={faEnvelope} />
            aatuesta00@hotmail.com
          </p>
        </a>
        <div>
          <FontAwesomeIcon
            icon={faSun}
            style={{ color: "#550", fontSize: "1.5rem" }}
          />
          <label className="switch">
            <input type="checkbox" onChange={setTheme} />
            <span className="slider round"></span>
          </label>
          <FontAwesomeIcon
            icon={faMoon}
            style={{ color: "#999", fontSize: "1.5rem" }}
          />
        </div>
      </div>
      <div className="footer__build">
        <p style={language === "english" ? {} : { display: "none" }}>
          <a href="https://www.netlify.com/" target="_blank" rel="noreferrer">
            Domain
          </a>
        </p>
        <p
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          <a href="https://www.netlify.com/" target="_blank" rel="noreferrer">
            Dominio
          </a>
        </p>
        <p style={language === "english" ? {} : { display: "none" }}>
          <a href="http://heroku.com/" target="_blank" rel="noreferrer">
            Server
          </a>
        </p>
        <p
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          <a href="http://heroku.com/" target="_blank" rel="noreferrer">
            Servidor
          </a>
        </p>
        <p style={language === "english" ? {} : { display: "none" }}>
          Builded with
        </p>
        <p
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          Desarrollado con
        </p>
        <div className="footer__build-icons">
          <a href="https://reactjs.org/" target="blank" rel="noreferrer">
            <FontAwesomeIcon icon={faReact} style={{ color: "#68f" }} />
          </a>
          <a href="https://fontawesome.com/" target="blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFontAwesome} style={{ color: "#88f" }} />
          </a>
          <a
            href="https://github.com/nfl/react-helmet#readme"
            target="blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faHardHat} style={{ color: "#fe8" }} />
          </a>
          <FontAwesomeIcon icon={faHeart} style={{ color: "#f44" }} />
          <FontAwesomeIcon icon={faCoffee} style={{ color: "#999" }} />
        </div>
        <select
          value={language ? language : "english"}
          onChange={changeData}
          className="language"
        >
          <option value="english">English</option>
          <option value="español">Español</option>
        </select>
      </div>
    </footer>
  );
}
